import mainSlider, { widgetName as sliderWidgetName } from './mainSlider';

function updateAutoplay(videoSettings) {
  let attrs = '';
  if (videoSettings.controls) {
    attrs += videoSettings.controls ? '&controls=1' : '&controls=0';
    attrs += videoSettings.autoplay ? '&autoplay=1' : '&autoplay=0';
    attrs += videoSettings.loop ? '&loop=1' : '&loop=0';
    attrs += videoSettings.muted ? '&muted=1' : '&muted=0';
  } else {
    attrs += '&controls=0&autoplay=1&loop=1&muted=1';
  }

  return attrs;
}

export default function vimeoWidget() {
  const widgetName = 'vimeoWidget';
  const widgetOpts = vimeoWidgetOpts;

  // Video Seetings
  const videoSettings = {
    controls: false, // if false, autoplay is set to true by default
    autoplay: true,
    loop: true,
    muted: true,
  };

  function createVimeoFeature(slide) {
    const videoConfig = updateAutoplay(videoSettings);

    $(`#${widgetName}`).find('.card-widget-title').remove();
    $(`#${widgetName}`).find('.buttonwrap').remove();

    let vimeoURLAttr = $(slide.Description).find('iframe').attr('src');
    vimeoURLAttr = `${vimeoURLAttr}${videoConfig}`;
    $(`#${widgetName}`).find('.card-widget-description iframe').attr('src', vimeoURLAttr);
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (slide, _owl, hasData) {
      if (hasData) {
        $(`#${sliderWidgetName}`).parent().remove();
        createVimeoFeature(slide.items[0]);
      } else {
        $(`#${widgetName}`).parent().remove();
        mainSlider();
      }
    },

    itemsPerPanel: 1,
    maxItemsVisible: 1,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
  });
}
